import { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";

export function useStockRegisterTypes(activeOnly = true) {
  const [registerTypes, setRegisterTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const AccessKey = localStorage.getItem("AccessKey");
    const UserID = localStorage.getItem("ID");
    const MemberType = localStorage.getItem("MemberType");

    axios({
      method: "post",
      url: config.base_url + "Stock/GetActiveStockRegisterTypes",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, MemberType },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          const list = response.data.ListofRecords || [];
          setRegisterTypes(activeOnly ? list.filter((x) => x.Is_Active) : list);
        } else {
          setRegisterTypes([]);
        }
        setLoading(false);
      })
      .catch(function () {
        setRegisterTypes([]);
        setLoading(false);
      });
  }, [activeOnly]);

  return { registerTypes, loading };
}

export default useStockRegisterTypes;
